import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWoningOpruimen1 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      d="M12.01 26.87a2 2 0 1 0 0-4 2 2 0 0 0 0 4M27.92 26.87a2 2 0 1 0 0-4 2 2 0 0 0 0 4M20.01 17.81a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M20 17.81a6 6 0 0 1 6 6v10H14v-10a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M17.036 12.345a3.03 3.03 0 1 0 6.008 0l.992-.13a4.03 4.03 0 1 1-7.992 0z"
      clipRule="evenodd"
    />
    <path
      fill="#F8BADD"
      d="M28 21.87H12v10h16z"
    />
    <path
      fill="#F170B8"
      d="m26.96 28.5-1.73-1.72-1.72 1.72h.9v2.37h1.64V28.5z"
    />
    <path
      fill="#F8BADD"
      d="m12.711 22.029-4.773-4.773-.707.707 4.773 4.773zM32.042 17.265l-4.773 4.773.707.707 4.773-4.773z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M15.76 28.69h-2.6v-1h2.6zM18.36 30.61h-5.2v-1h5.2z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWoningOpruimen1);

export default ForwardRef;
